import React from 'react';
export function Footer() {
  return <footer className="bg-slate-100 text-slate-500 py-12 border-t border-slate-200" data-id="element-123">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-124">
        {/* Top row: copyright + nav */}
        <div className="text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-6 pb-8 border-b border-slate-200" data-id="element-125">
          <p className="text-sm text-slate-900 font-medium" data-id="element-126">
            © 2026 The Auction Protocol. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm font-medium" data-id="element-127">
            <a href="#" className="hover:text-orange-500 transition-colors" data-id="element-128">
              Terms
            </a>
            <a href="#" className="hover:text-orange-500 transition-colors" data-id="element-129">
              Privacy
            </a>
            <a href="#" className="hover:text-orange-500 transition-colors" data-id="element-130">
              Contact
            </a>
          </div>
        </div>

        {/* Legal disclaimers */}
        <div className="pt-8 space-y-4 text-xs leading-relaxed text-slate-500 text-left" data-id="element-131">
          <p className="text-slate-700 font-semibold uppercase tracking-wider text-[11px]" data-id="element-132">
            Important Legal Disclaimers — Please Read
          </p>

          <p data-id="element-133">
            <strong className="text-slate-700" data-id="element-134">
              For Information &amp; Educational Purposes Only.
            </strong>{' '}
            This product, website, and all related materials are sold and
            provided strictly for general informational and educational
            purposes. Nothing contained herein is intended to be, and shall not
            be construed as, financial, investment, legal, tax, accounting, or
            real estate advice of any kind. We are not a law firm, brokerage,
            lender, financial advisor, or licensed real estate professional, and
            no professional-client or fiduciary relationship is created by your
            purchase or use of these materials.
          </p>

          <p data-id="element-135">
            <strong className="text-slate-700" data-id="element-136">
              No Guarantees of Results.
            </strong>{' '}
            We make no representations, warranties, or guarantees, express or
            implied, regarding any specific outcome, savings, discount, profit,
            or result. Any examples, figures, or references to buying a home "up
            to 50% off" or similar statements are illustrative only, are not a
            promise or guarantee, and are not typical. Your results depend
            entirely on numerous factors outside our control, including your own
            effort, experience, diligence, local market conditions, financing,
            and applicable laws. You may achieve different results, no results,
            or experience a financial loss.
          </p>

          <p data-id="element-137">
            <strong className="text-slate-700" data-id="element-138">Assumption of Risk.</strong> Real
            estate transactions, property auctions, and any related activities
            involve substantial risk, including the potential loss of your
            entire investment. Auction properties may carry liens, debts, title
            defects, occupancy issues, undisclosed conditions, and other risks.
            You are solely responsible for conducting your own independent due
            diligence and for any and all decisions you make. You expressly
            assume all such risks.
          </p>

          <p data-id="element-139">
            <strong className="text-slate-700" data-id="element-140">Consult Professionals.</strong>{' '}
            Before making any financial, legal, or real estate decision, you
            should consult with your own qualified, licensed attorney,
            accountant, financial advisor, and/or real estate professional who
            can review your specific situation. Laws, rules, and auction
            procedures vary by state, county, and jurisdiction and change over
            time.
          </p>

          <p data-id="element-141">
            <strong className="text-slate-700" data-id="element-142">No Affiliation.</strong> We are
            not affiliated with, endorsed by, or sponsored by any government
            agency, auction house, bank, lender, real estate brokerage, or any
            third-party platform referenced. All trademarks and brand names are
            the property of their respective owners.
          </p>

          <p data-id="element-143">
            <strong className="text-slate-700" data-id="element-144">Limitation of Liability.</strong>{' '}
            To the maximum extent permitted by applicable law, in no event shall
            the publisher, its owners, officers, employees, affiliates, or
            agents be liable for any direct, indirect, incidental,
            consequential, special, punitive, or exemplary damages arising out
            of or related to your access to, use of, or reliance on these
            materials, even if advised of the possibility of such damages. Your
            sole and exclusive remedy for dissatisfaction is to request a refund
            under the stated guarantee.
          </p>

          <p data-id="element-145">
            By purchasing or using these materials, you acknowledge that you
            have read, understood, and agreed to these disclaimers, our Terms of
            Service, and our Privacy Policy.
          </p>
        </div>
      </div>
    </footer>;
}